/**
 * Mind-map-only build: AI / copilot is disabled entirely, so the large AI
 * extension subtree is never registered or initialized at runtime.
 */
export const useEnableAI = () => {
  return false;
};
